/* BECAY - estabilidad visual al filtrar/ordenar colecciones.
   theme.js (compilado, ~300 KB) reemplaza la seccion entera en cada
   "facet:update" sin reservar altura y auto-scrollea siempre; este parche
   vive en un asset aparte porque theme.js es demasiado grande para
   editarse via API desde el entorno de desarrollo.
   1) Pinna min-height de la seccion al empezar el update y la libera
      cuando el nuevo grid ya se ha asentado -> el grid no colapsa.
   2) Omite el scrollIntoView de theme.js sobre .collection cuando su
      parte superior ya esta visible -> sin salto de scroll gratuito. */
(function () {
  'use strict';

  function clearPin(section) {
    var pin = section.__bcyPin;
    if (!pin) return;
    if (pin.observer) pin.observer.disconnect();
    if (pin.releaseTimer) clearTimeout(pin.releaseTimer);
    if (pin.safetyTimer) clearTimeout(pin.safetyTimer);
    section.__bcyPin = null;
  }

  document.addEventListener('facet:update', function (event) {
    try {
      var url = event.detail && event.detail.url;
      if (!url || !url.searchParams) return;
      var section = document.getElementById('shopify-section-' + url.searchParams.get('section_id'));
      if (!section) return;
      /* Un pin por seccion: filtrar varias veces seguidas no debe dejar
         timers/observers viejos soltando el min-height del update nuevo */
      clearPin(section);
      section.style.minHeight = section.offsetHeight + 'px';
      var pin = { observer: null, releaseTimer: null, safetyTimer: null };
      section.__bcyPin = pin;
      pin.observer = new MutationObserver(function () {
        pin.observer.disconnect();
        pin.releaseTimer = setTimeout(function () {
          section.style.minHeight = '';
          clearPin(section);
        }, 1200);
      });
      pin.observer.observe(section, { childList: true });
      /* Red de seguridad por si el update falla y no hay mutacion */
      pin.safetyTimer = setTimeout(function () {
        section.style.minHeight = '';
        clearPin(section);
      }, 8000);
    } catch (e) {}
  });

  try {
    var originalScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (this.classList && this.classList.contains('collection')) {
        var top = this.getBoundingClientRect().top;
        if (top >= 0 && top < window.innerHeight) {
          return; /* ya visible en pantalla: no hace falta scrollear */
        }
      }
      return originalScrollIntoView.apply(this, arguments);
    };
  } catch (e) {}
})();
